import { useFeatureAccess } from "../../access-control/hooks/useFeatureAccess";
import { useAuthContext } from "../../auth/state/AuthContext";
import AdminUwhcMonitoringPanel from "../components/monitoring/AdminUwhcMonitoringPanel";
import CronJobsMonitoringPanel from "../components/monitoring/CronJobsMonitoringPanel";
import FeatureMonitoringPanel from "../components/monitoring/FeatureMonitoringPanel";
import { ADMIN_MONITORING_SECTIONS, ADMIN_PATHS, type AdminMonitoringSectionId } from "../models/admin.models";
import { hasAdminSidebarFeatureSectionAccess } from "../utils/admin-entry-access.constants";
import { Navigate } from "react-router-dom";

interface Props {
  section?: AdminMonitoringSectionId;
}

const AdminMonitoringPage = ({ section }: Props) => {
  const { hasFeature } = useFeatureAccess();
  const groups = useAuthContext().state.user?.accessToken?.groups ?? [];

  if (!section) {
    const firstAllowedSection = ADMIN_MONITORING_SECTIONS.find((item) =>
      hasAdminSidebarFeatureSectionAccess(item, groups, hasFeature),
    );

    return <Navigate to={firstAllowedSection?.path ?? ADMIN_PATHS.root} replace />;
  }

  if (section === "cronJobs") {
    return <CronJobsMonitoringPanel />;
  }

  if (section === "uwhc") {
    return <AdminUwhcMonitoringPanel />;
  }

  return <FeatureMonitoringPanel section={section} />;
};

export default AdminMonitoringPage;
